module.exports = __webpack_public_path__ + "img/OGG_Background_Purple.6d50140a.png";